/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiStorageStockEntry } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of StorageStockController.
 */
export class StorageStockRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /storage_stock
     */
    public getStock(storageLocationId: string, validAt: string, bookingId: string | undefined): Promise<Result<ApiStorageStockEntry[]>> {
        const query = new URLSearchParams();
        query.set('storage_location_id', `${storageLocationId}`);
        query.set('valid_at', `${validAt}`);
        if (bookingId !== undefined) {
            query.set('booking_id', `${bookingId}`);
        }

        return this.http.get<Result<ApiStorageStockEntry[]>>('/storage_stock', query);
    }
}
